export function normalizeEnergyBillSsn(value: string): string | null {
  const digits = value.replace(/\D/g, "")
  return digits.length === 0 || digits.length === 9 ? digits : null
}
